import styled from '@emotion/styled';
import {Avatar, Grid, Toolbar} from '@mui/material';

export const ProfileDetailsGrid = styled(Grid)`
  text-align: center;
  margin: 0 auto;
  border-radius: 8px;
  width: 55%;
  margin-bottom: 1em;
`;

export const ToolBarStyle = styled(Toolbar)`
  height: 70px;
  padding: 0 0 0 16px !important;
`;

export const StyledFab = styled('div')`
  position: absolute;
  z-index: 1;
  top: 18px;
  left: 0;
  right: 0;
`;

export const PersonalDetails = styled('div')`
  padding: 1.25em;
`;

export const SubHeading = styled('div')`
  padding: 0.4em;
`;

export const AvatarStyling = styled(Avatar)`
  margin: auto;
  height: 35px;
  width: 35px;
`;

export const MRNNumber = styled('div')`
  justify-content: center;
`;

export const PersonalInfo = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`;
